document.addEventListener("DOMContentLoaded", function () {
  const productGallery = document.querySelector(".product-gallery");
  const toggleGallery = document.querySelector("#toggle-image");

 
  if (toggleGallery) {
    toggleGallery.addEventListener("click", function () {
      if (window.innerWidth < 1180) return;

      document.querySelector(".product-images-wrapper")?.classList.toggle("expand");
      document.querySelector(".modal-product-details")?.classList.toggle("move-right");
      productGallery?.classList.toggle("no-padding");
    });
  }

  if (productGallery) {
    productGallery.addEventListener("click", function () {
      if (window.innerWidth < 1180) return;

      productGallery.classList.toggle("full-size");
      document.querySelector(".recommended-container")?.classList.toggle("move-left");
      document.querySelector("#product-overlays")?.classList.toggle("move-width");
      document.querySelector(".product-details")?.classList.toggle("move-right");
    });
  }
});